import { defineMessages } from 'react-intl';

const _default_1: {
	clearAllButtonTooltip: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	selectedText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	clearAllButtonTooltip: {
		id: 'atlassian-studio-ui-components.bulk-toolbar.clearAllButtonTooltip',
		defaultMessage: 'Clear all',
		description: 'Tool tip for the button that clears all the selections',
	},
	selectedText: {
		id: 'atlassian-studio-ui-components.bulk-toolbar.selectedText',
		defaultMessage: 'selected',
		description:
			'Text that comes after a number to show how many items are selected for bulk edititing',
	},
});
export default _default_1;
